webpackJsonpUpdateBris([93],{

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NS = 'KlevuResultsListingBlock';
var CLS = 'klevuResultsListingBlock';
var CLS_LOADING = 'is-loading';
var EVT_SEARCH_START = CLS + '.search.start';
var EVT_SEARCH_END = CLS + '.search.end';

var KlevuResultsListingBlock = exports.KlevuResultsListingBlock = function () {
	function KlevuResultsListingBlock(el) {
		_classCallCheck(this, KlevuResultsListingBlock);

		// $el is the blk node return by the loadKlevuResultsListingBlock function
		this.el = el;
		this.$el = $(el);

		this.checkQueryString();
		this.attachEvent();
	}

	_createClass(KlevuResultsListingBlock, [{
		key: 'checkQueryString',
		value: function checkQueryString() {
			var urlParams = new URLSearchParams(window.location.search);
			if (Array.from(urlParams).length > 0) {
				this.$el.addClass(CLS_LOADING);
			}
		}
	}, {
		key: 'attachEvent',
		value: function attachEvent() {
			var _this = this;

			this.el.addEventListener(EVT_SEARCH_START, function () {
				_this.$el.addClass(CLS_LOADING);
			});

			this.el.addEventListener(EVT_SEARCH_END, function () {
				_this.$el.removeClass(CLS_LOADING);
			});
		}

		/*
  Need to append code below manually to each Klevu module like sort, limit, pagination, etc,
  cause couldn't find a generic function to call this loading
  	var $landing = document.querySelector('.klevuResultsListingBlock');
  if ($landing) {
  	var searchStartEvent = new CustomEvent('klevuResultsListingBlock.search.start');
  	$landing.dispatchEvent(searchStartEvent);
  }
  */

	}]);

	return KlevuResultsListingBlock;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ })

});


// WEBPACK FOOTER //
// 1742452116000.blk-klevu-results-listing-block-chunk.js